import React from 'react';
import { StarIcon } from 'lucide-react';
import { heroQuotes } from '../data/content';
const stats = [{
  value: '2.847',
  label: 'mujeres rescatadas'
}, {
  value: '6 + 6',
  label: 'tomos + bonos'
}, {
  value: '4.9/5',
  label: 'calificación'
}];
export function ProofBar() {
  return <section className="w-full bg-blue-900 py-14 text-white md:py-20" data-id="element-185" data-mp="cjvt9kislkd3">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-186" data-mp="chsry4c6w4t2">
        <dl className="grid gap-8 text-center sm:grid-cols-3" data-id="element-187" data-mp="3uoyxz44ujucz">
          {stats.map(stat => <div key={stat.label} data-id="element-188" data-mp="3k8s8ztz6gkk">
              <dt className="sr-only" data-id="element-189" data-mp="3h4f3cyj8ahr">{stat.label}</dt>
              <dd data-id="element-190" data-mp="3ksw04ah12hvu">
                <span className="block font-display text-4xl font-extrabold tracking-tight text-gold-300 md:text-5xl" data-id="element-191" data-mp="3ktf7wycyrpw5">
                  {stat.value}
                </span>
                <span className="mt-1 block text-sm font-semibold uppercase tracking-[0.14em] text-blue-100" data-id="element-192" data-mp="1j1ak9z2hzer8">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <h2 className="mt-16 text-center font-display text-2xl font-extrabold tracking-tight md:text-3xl" data-id="element-193" data-mp="2sd40yahp63t7">
          Lo que dicen las mujeres que ya empezaron
        </h2>

        <ul className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-194" data-mp="323qb3p6na24i">
          {heroQuotes.map(quote => <li key={quote.author} className="flex h-full flex-col rounded-2xl bg-white p-6 text-left shadow-lift" data-id="element-195" data-mp="2x6q5ffdpj1dx">
              <div className="flex items-center gap-3" data-id="element-196" data-mp="24gzokykoxle4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-600 font-display text-xs font-bold text-gold-200" data-id="element-197" data-mp="24ikh6ing2u9c">
                  {quote.initials}
                </span>
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-198" data-mp="2edw1dghmgtoh">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-199" data-mp="3puvqy4cl4uet" data-mpi={index} />)}
                </span>
              </div>
              <p className="mt-4 text-lg leading-snug text-ink" data-id="element-200" data-mp="2rkmcj7hom3l7">“{quote.quote}”</p>
              <p className="mt-auto pt-4 text-sm font-semibold text-blue-700" data-id="element-201" data-mp="2wi4gejgudsmc">
                — {quote.author}, {quote.city}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}